import type { PropsWithChildren } from "react";

const WorkspaceNavBar = ({ children }: PropsWithChildren) => {
  return <>{children}</>;
};

WorkspaceNavBar.displayName = "WorkspaceNavBar";

export default WorkspaceNavBar;
